/**
 * 电商套图 · 顶部阶段导航（配置 / 分镜 / 结果）
 */
import { suiteTheme } from '../theme';

export type SuiteStage = 'setup' | 'storyboard' | 'results';

const STAGES: Array<{ key: SuiteStage; index: number; label: string }> = [
  { key: 'setup', index: 1, label: '配置' },
  { key: 'storyboard', index: 2, label: '分镜' },
  { key: 'results', index: 3, label: '结果' },
];

export function StageBar({
  current,
  onChange,
}: {
  current: SuiteStage;
  onChange: (stage: SuiteStage) => void;
}) {
  return (
    <div className={suiteTheme.stageBar}>
      {STAGES.map((stage) => {
        const active = stage.key === current;
        return (
          <button
            key={stage.key}
            type="button"
            onClick={() => onChange(stage.key)}
            className={`${suiteTheme.stageItem} ${active ? suiteTheme.stageItemActive : suiteTheme.stageItemInactive}`}
          >
            <span className={active ? 'text-blue-600/70' : 'text-zinc-500'}>{stage.index}</span>
            {stage.label}
          </button>
        );
      })}
    </div>
  );
}
